<template>
<div id="contents">

  <div id="recruit_requirements" class="page_contents">

    <div id="recruit_requirements_contents">
      <div class="requirements">
        <h1 class="requirements_ttl">経験者採用<br />募集要項</h1>
        <p class="close_icon"><router-link v-bind:to="{name: 'recruit_index'}"><img src="../assets/img/recruit_requirements/close_icon.png" alt="×" width="23"></router-link></p>
        <div class="requirements_desc">
          <p>当社では主要取引先の『テレビ朝日』をメインに、<br />『NHK』『TBS』『フジテレビ』『BS各局』などでのレギュラー番組を数多く制作しています。<br />さらに『ABEMA』『YouTube』など数々の人気Webコンテンツも創出しています。</p>
          <p>幅広いジャンルでのコンテンツ制作が増えている今、<br />番組・コンテンツ制作ディレクター・プロデューサーを募集！<br />スケールの大きな仕事であなたの実力を発揮しませんか？</p>
          <p>以下の応募要項を確認いただいたうえで、<br />ページ下部にある「エントリーシート ／ 履歴書」をダウンロードし、記入をお願いいたします。</p>
          <p>応募書類は<a href="mailto:career@tv-asahipro.co.jp">career@tv-asahipro.co.jp</a>までメールにてお送りください。ご応募お待ちしております。</p>
        </div>
        <div class="requirement_list">
          <dl>
            <dt><p>募集職種</p></dt>
            <dd><p>ディレクター／プロデューサー（総合演出、チーフ経験者は優遇します）</p></dd>
            <dt><p>雇用形態</p></dt>
            <dd><p>契約社員　※最長2年　正社員採用試験随時あり</p></dd>
            <dt><p>応募資格</p></dt>
            <dd><p>テレビ番組などの映像コンテンツを自ら企画し制作した経験がある方</p></dd>
            <dt><p>業務内容</p></dt>
            <dd>
              <ol>
                <li>コンテンツ制作クリエイター・プロデューサー<br />報道情報生番組、ドキュメンタリー、バラエティ、ドラマ、映画、ABEMA・YouTube等のネットコンテンツの企画・制作業務</li>
                <li>デジタルビジネスクリエイター・プロデューサー<br />YouTube・TikTok等の動画制作をはじめ、インターネットサービスやデジタルを駆使した新たなコンテンツ展開を仕掛けるビジネスの企画・開発業務</li>
              </ol>
              <p>ゴールデン帯番組や各種コンテンツ作品の総合演出・プロデューサー候補として、<br />まずは「報道情報番組」「バラエティ番組」などで経験＆実績を活かせる制作から始めていただきます。<br />入社年次や年齢に関係なく、自身の立案、クライアントからの指名、制作実績などが評価に繋がります。</p>
            </dd>
            <dt><p>キャリアプラン</p></dt>
            <dd>
              <p>20代後半から制作現場の最前線で活躍しています。<br />【モデル社員例】<br />・29歳→報道情報番組チーフディレクター<br />・31歳→YouTubeでヒットを連発<br />・37歳→バラエティ番組での総合演出</p>
            </dd>
            <dt><p>働き方改革への取り組み</p></dt>
            <dd>
              <p>"出社しない"コンテンツ制作を実践しています。<br />【例】<br />・リニューアルしたばかりのオフィスでフリーアドレス制を採用<br />・在宅勤務を推奨→ 会議は原則オンライン化<br />・業務オンライン化→連絡ツールはGoogle Chat・LINE WORKSなどを利用</p>
            </dd>
            <dt><p>給与</p></dt>
            <dd class="salary">
              <p>月給33万円以上（別途賞与支給あり）<br /><span class="indent">※前職給与を最大限考慮します。</span><br /><span class="indent">※経験・年齢を考慮の上、当社規定により決定します。</span></p>
              <p>＜モデル年収例＞<br />　※正社員登用後（賞与・諸手当含む）<br />　年収770万円 ／ 27歳 ディレクター職<br />　年収850万円 ／ 30歳 ディレクター職<br />　年収970万円 ／ 33歳 ディレクター職<br />　年収1050万円 ／ 36歳 チーフディレクター職</p>
            </dd>
            <dt><p>賞与</p></dt>
            <dd><p>年4回（4月、6月、10月、12月）</p></dd>
            <dt><p>諸手当</p></dt>
            <dd><p>通勤交通費支給<br />休日出勤手当<br />深夜勤務手当　ほか</p></dd>
            <dt><p>勤務時間</p></dt>
            <dd><p>専門業務型裁量労働制（1日9時間）</p></dd>
            <dt><p>休日・休暇</p></dt>
            <dd><p>各種社会保険完備<br />人間ドック、スーパー人間ドック<br />テーマパークコーポレート利用券<br />TOHOシネマズ映画鑑賞チケット<br />厚生会マイチョイス<br />保養所（リゾートホテル）<br />チケットレストラン加盟店による食事補助<br />編集用ノートPC購入費用補助<br />クラブ活動補助<br />各種慶弔見舞金<br />テレビ朝日健康保険組合<br />ノートPC、iPhone貸与<br />外部教育講座の受講<br />人材育成制度<br />育児介護支援制度（ベビーシッター利用費用補助クーポン）</p></dd>
          </dl>
        </div>
      </div>
      <div class="document">
        <h2 class="document_ttl">応募書類のダウンロードはこちら</h2>
        <p class="document_desc">PCサイトではExcelをダウンロードしていただけます。</p>
        <div class="document_list">
          <p class="btn"><a href="https://www.tv-asahipro.co.jp/pdf/entry_sheet.pdf" download="entry_sheet.pdf" target="_blank">エントリーシート ／ 履歴書</a></p>
        </div>
      </div>
    </div><!-- #recruit_requirements_contents -->
  </div><!-- #recruit_requirements -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'recruit_requirements',
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    $('.js-click_box').click(function(){
      var link = $(this).find('a').attr('href');
      console.log(link);
      window.open(link);
      return false;
    });
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/recruit_requirements.vue